import Header from "../Component/UserEnd/Header";
import Privacy from "../Component/UserEnd/Privacy";
import Footer from "../Component/UserEnd/Footer";

function PrivacyPolicy() {
    return (
        <>
            <Header />
            <Privacy />
            <Footer />
        </>
    );
}

export default PrivacyPolicy;
